import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import { useThunk } from "../../hooks/useThunk";
import { signout } from "../../store";

import avatar from "../../assets/logo/logo.svg";
import { SectionTitle } from "../common/PageSectionTitle";
import AvatarDropdown from "./AvatarDropdown";
import { getRemixerUserById } from "../../services/thunks/remixerUserThunks";
import showToast from "../../utils/toastNotifications";
const { roles } = require("../../constants/commonConstants");

const TopNavbar = ({ title }) => {
  const auth = useSelector((state) => state.auth);
  const { role } = auth;
  const isRemixer = role === roles.REMIXER;

  const [doGetRemixerUserById] = useThunk(getRemixerUserById);

  const [showDropdown, setShowDropdown] = useState(false);
  const [currentRemixer, setCurrentRemixer] = useState({});

  const containerRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const fetchCurrentRemixerUser = async () => {
      if (!isRemixer || !auth.user?._id) return;

      const res = await doGetRemixerUserById({
        token: auth.token,
        id: auth.user._id,
      });
      if (!res?.success) {
        return;
      }

      setCurrentRemixer(res?.response.data);
    };

    fetchCurrentRemixerUser();
  }, [auth.token, auth.user?._id, isRemixer]);

  return (
    <>
      <header className="bg-[#0B0D12] w-full text-white px-3 md:px-6 h-[70px] flex items-center justify-between border-b border-[#1F1F1F]">
        <SectionTitle
          value={title}
          className="gradient-stroke-text font-semibold"
        />

        <div className="relative" ref={containerRef}>
          <div className="flex items-center gap-3 ">
            <div
              className="w-10 h-10 rounded-full overflow-hidden border border-[#51F8EF] shadow-md cursor-pointer flex items-center justify-center bg-[#1A1D23]"
              onClick={() => setShowDropdown((prev) => !prev)}
            >
              <img
                src={avatar}
                alt="User Avatar"
                className="w-6 h-6 object-contain"
              />
            </div>
            <div className="flex flex-col items-start leading-tight font-['Mona_Sans'] ">
              <p className="text-sm font-medium text-[#FFFFFF]">
                {isRemixer
                  ? currentRemixer?.remixerName
                  : "Admin Supreme Edits"}
              </p>
              <span className="text-[#AEB9E1] text-xs cursor-pointer font-['Mona_Sans'] font-medium hidden">
                Account settings
              </span>
            </div>
          </div>

          {showDropdown && (
            <AvatarDropdown
              isRemixer={isRemixer}
              remixer={currentRemixer}
              onLogout={() => dispatch(signout())}
            />
          )}
        </div>
      </header>
    </>
  );
};

export default TopNavbar;
